export default class AppCodeHighlight {
    constructor () {
        this.init();
    }

    init () {
        $('code[data-toggle=highlight]').each(function (i, block) {
            hljs.highlightBlock(block);
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/codeHighlight.js